import { Action } from '@ngrx/store';

import { PageableItems } from '®shared/reading-list/models';

export enum PageableItemsActionTypes {
  ITEM_PAGE_INITIALISED = '[PageableItems] item page initialised',
  ITEM_PAGE_LOADED = '[PageableItems] item page loaded',
  ITEM_PAGE_LOADING_FAILED = '[PageableItems] item page loading failed',
}

export class ItemPagesInitialisedAction implements Action {
  readonly type = PageableItemsActionTypes.ITEM_PAGE_INITIALISED;

  constructor(public payload: ItemPageInitialisedPayload) {}
}

export class ItemPageLoadedAction implements Action {
  readonly type = PageableItemsActionTypes.ITEM_PAGE_LOADED;

  constructor(public payload: PageableItems) {}
}

export class ItemPageLoadingFailed implements Action {
  readonly type = PageableItemsActionTypes.ITEM_PAGE_LOADING_FAILED;

  constructor(public payload: ItemPageLoadingFailedPayload) {}
}

export type PageableItemsActions =
  | ItemPagesInitialisedAction
  | ItemPageLoadedAction
  | ItemPageLoadingFailed;

type ItemPageInitialisedPayload = {
  pageOffsets: number[];
};

type ItemPageLoadingFailedPayload = {
  pageOffset: number;
  error: any;
};
